import { PendingSubmissionModel, UnsavedSubmissionModel } from "../reduxToolkit/submissionsSlice";
import { selectPendingExpenses } from "../../lib/expenses/pendingExpenses";
import { useAppSelector } from "./reduxToolkit";

// Re-exported so existing `from '.../hooks/usePendingExpenses'` imports keep
// resolving. The selector itself moved to lib/expenses/pendingExpenses so that
// lib/todos can use it without a lib -> app/hooks dependency.
export { selectPendingExpenses }

export function usePendingExpenses(submission: PendingSubmissionModel | UnsavedSubmissionModel) {
  return useAppSelector(selectPendingExpenses(submission))
}
